import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ui} from '@joint/plus';
import * as joint from '@joint/plus';
import RappidService from "../../services/jointjs/logigramme-service";
import {StencilService} from "../../services/jointjs/stencil-service";
import {ToolbarService} from "../../services/jointjs/toolbar-service";
import {InspectorService} from "../../services/jointjs/inspector-service";
import {HaloService} from "../../services/jointjs/halo-service";
import {KeyboardService} from "../../services/jointjs/keyboard-service";
import {ProceduresService} from "../../services/procedures/procedures.service";
import {AnnexesService} from "../../services/annexes/annexes.service";
import {Router} from "@angular/router";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-jointjs-plus',
  standalone: true,
  templateUrl: './jointjs-plus.component.html',
  imports: [
    NgClass
  ],
  styleUrl: './jointjs-plus.component.scss'
})
export class JointjsPlusComponent implements OnInit {

  @Output() closeDialogEvent = new EventEmitter<boolean>();
  @Output() graphChanged = new EventEmitter<any>();
  @Input() logigramme!: any;
  private rappid: RappidService;
  private dialog: ui.Dialog;
  @Input() readOnly!: boolean | undefined;


  constructor(private element: ElementRef, private procedureService: ProceduresService, private annexeService: AnnexesService, private router: Router) {
  }

  ngOnInit() {

    this.rappid = new RappidService(
      this.element.nativeElement,
      new StencilService(),
      new ToolbarService(),
      new InspectorService(this.procedureService, this.annexeService, this.logigramme),
      new HaloService(),
      new KeyboardService(),
      this.readOnly
    );
    this.rappid.startRappid();

    if (this.logigramme && Object.keys(this.logigramme).length > 0) {
      this.rappid.graph.fromJSON(this.logigramme);
    }


    this.dialog = new ui.Dialog({
      width: 250,
      title: 'Information',
      content: '<div id="informationText" style="width: 100%; word-break: break-all"></div>',
      buttons: [
        { content: 'Close', action: 'close' }
      ]
    });
    this.dialog = new ui.Dialog({
      width: 250,
      title: 'Information',
      content: '<p id="informationText" style="width: 100%; word-break: break-all"></p>',
      buttons: [
        { content: 'Fermer', action: 'close' }
      ]
    });

    this.rappid.graph.on('all', () => {
      this.graphChanged.emit(this.rappid.graph.toJSON());
    });

    this.rappid.paperScroller.scroll(0,0);

    if(this.readOnly) {
      // vu qu'on est en readOnly, on met le cursor à auto dans le paper et pointer dans les cells (ce dernier est géré en bas dans la méthode handleHoverEvents).
      this.rappid.paperScroller.setCursor("auto");
      // vu qu'on ne veut pas d'interaction sur cette vue, on utilise on disable toute sorte d'interaction.
      this.rappid.paper.setInteractivity(false);
      // Une fois le logigramme construit, on ajoute le handler des clicks events et les hovers events.
      this.handleClickEvents();
      this.handleHoverEvents();
    }
  }

  handleClickEvents() {
    this.rappid.paper.on('cell:pointerclick', (cellView) => {
      const cell = cellView.model;

      // Premièrement, si l'élément n'est pas un link, on enlève la surbrillance d'avant et on met en surbrillance l'élément en question.
      if(!cell.isLink()) {
        this.rappid.paper.removeTools();
        const boundaryTool = new joint.elementTools.Boundary();
        const toolsView = new joint.dia.ToolsView({ tools: [boundaryTool] });
        cellView.addTools(toolsView);
      }


      const informationText = cell.prop('attrs/label/informationText') || '';
      const annexeText = cell.prop('attrs/label/annexeSearch') || '';
      const cellTitreDialog = cell.prop('attrs/label/titleOfDialog') || null;
      // On récupère l'id de l'élément auquel on veut scroll
      const elementDiagrammeIdToScrollTo = cell.prop('attrs/label/elementDiagrammeSearch') || '';
      const procedureIdToOpenInNewTab = cell.prop('attrs/label/procedureSearch') || '';

      // Gestion de la modale d'information
      if (informationText) {
        if(cellTitreDialog) {
          this.dialog.options.title = cellTitreDialog;
        } else {
          this.dialog.options.title = 'Information';
        }
        this.dialog.open();
        const infoElement = document.getElementById('informationText') as HTMLDivElement;
        if (infoElement) {
          infoElement.textContent = informationText;
        }
        this.dialog.on('action:close', () => {
          this.dialog.close();
        });

      } else if (annexeText) { // Gestion des annexes
        window.open(annexeText, '_blank');
      } else if (elementDiagrammeIdToScrollTo) {  // gestion du scroll au diagramme, si c'est un goTo Element on scroll vers l'élément souhaité sinon si c'est une procédure, on l'ouvre dans un nouvel onglet
        // via l'id on récupère l'objet cell
        let cellToScrollTo = this.logigramme.cells.find((cell: any) => cell.id == elementDiagrammeIdToScrollTo);
        if(cellToScrollTo) {
          let x = cellToScrollTo.position.x;
          let y = cellToScrollTo.position.y;

          this.rappid.paperScroller.scroll(x, y);
        }
      } else if (procedureIdToOpenInNewTab) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree([`/procedures/modifier-procedure/${procedureIdToOpenInNewTab}`], {queryParams: { openLogigramme : true}})
        );
        window.open(url, '_blank');
      } else if( cell.attributes?.['isFinProcedure'] ) {
         this.closeDialogEvent.emit(true);
      }
    });
  }

  handleHoverEvents(){
    this.rappid.paper.on('cell:mouseover', (cellView) => {
      // par default, on met le cursor à auto, le cas d'une cell clickable est gérée aprés en bas
      cellView.el.style.cursor = 'auto';
      const cell = cellView.model;
      // On récupère l'id de l'élément auquel on veut scroll ou de la procédure à ouvrir dans un nouvel onglet
      const elementDiagrammeIdToScrollTo = cell.prop('attrs/label/elementDiagrammeSearch') || '';
      const procedureIdToOpenInNewTab = cell.prop('attrs/label/procedureSearch') || '';
      const informationText = cell.prop('attrs/label/informationText') || '';
      const annexeText = cell.prop('attrs/label/annexeSearch') || '';
      if(!cell.isLink()) {
        cellView.el.style.cursor = 'pointer';
      } else {
        cellView.el.style.cursor = 'auto';
      }

      // On commente ce bloc pour le moment, car pour l'instant, il faut pouvoir cliquer sur tous les éléments et ajouter une surbrillance.
      /*
      if(elementDiagrammeIdToScrollTo || procedureIdToOpenInNewTab || informationText || annexeText || cell.attributes?.['isFinProcedure'] ) {
        cellView.el.style.cursor = 'pointer';
      }
      */
    })
  }

}
